import axios from "axios";

const GetAccessPrivilegesByEmployee = async (userId) => {
    return axios.get(
        "Privileges/GetAccessPrivileges",
        {
            params: {
                p_userId: userId,
                P_USERID: userId,
            }
        }
    )
}

const UpdateAccessPrivileges = async (payload) => {
    return axios.post(
        "Privileges/UpdatePrivileges",
        null,
        {
            params: {
                P_PRIVILEGEID: payload.privilegeId,
                P_ACCESSRIGHTS: payload.accessRights,
                p_status: payload.status,
                P_STATUS: payload.status,
                P_UPDATEDBY: payload.updatedBy ?? "admin",
            }
        }
    );
}

const AddAccessPrivileges = async (payload) => {
    const params = {
        P_USERID: payload.userId,
        P_ID: payload.userId,
        P_APPLICATIONID: payload.applicationId,
        P_ROLETYPE: payload.roleType,
        P_ACCESSRIGHTS: payload.accessRights,
        p_status: payload.status ?? "A",
        P_STATUS: payload.status ?? "A",
        P_CREATEDBY: payload.createdBy ?? "admin",
    };

    if (payload.privilegeId) {
        params.p_privilegeId = payload.privilegeId;
        params.P_PRIVILEGEID = payload.privilegeId;
    }

    return axios.post(
        "Privileges/AddPrivileges",
        null,
        { params }
    );
}

const GetSysApplication = async () => {
    return axios.get("Privileges/GetSysApplication");
}

const GetPrivilegesBySystemId = async (systemId) => {
    return axios.get(
        "SystemApplication/GetSys",
        {
            params: {
                P_SYSTEMID: systemId,
            }
        }
    )
}

const UpdateSystemPrivileges = async (payload) => {
    return axios.post(
        "SystemApplication/UpdateSys",
        null,
        {
            params: {
                P_APPLICATIONID: payload.applicationId,
                P_DESCRIPTION: payload.description,
                P_UPDATEDBY: payload.updatedBy,
                p_menuId: payload.menuId,
            }
        }
    );
}

const AddSystemPrivileges = async (payload) => {
    return axios.post(
        "SystemApplication/AddSys",
        null,
        {
            params: {
                P_MENUID: payload.menuId,
                P_DESCRIPTION: payload.description,
                P_APPLICATIONTYPE: payload.applicationType,
                P_APPLICATION: payload.application,
                P_APPLICATIONPATH: payload.applicationPath,
                P_SYSTEMID: payload.systemId,
                P_CREATEDBY: payload.createdBy ?? "admin",
            }
        }
    );
}

const PrivilegeService = {
    GetAccessPrivilegesByEmployee,
    UpdateAccessPrivileges,
    AddAccessPrivileges,
    GetSysApplication,
    GetPrivilegesBySystemId,
    UpdateSystemPrivileges,
    AddSystemPrivileges,
}

export default PrivilegeService;